// @ts-strict-ignore
import type { DefaultOptionType as SelectOption } from "@braze/beacon-lab-select/dist/components/Select/types";

export const optionValueForSelect = (n): SelectOption => {
  return n ? { label: "" + n, value: "" + n } : n;
};
